import { createSlice } from "@reduxjs/toolkit";
// import { jwtDecode } from "jwt-decode";
const tokenFromStorage = localStorage.getItem("token");

const userIdFromStorage = localStorage.getItem("userId");
const permissionFromStorage = localStorage.getItem("permission");
const initialState = {
  isAuthenticated: !!tokenFromStorage,
  user: null,
  token: tokenFromStorage || null,
  userId: userIdFromStorage || null,
  loading: false,
  error: null,
  sessionChecked: false,
  permission: permissionFromStorage ? JSON.parse(permissionFromStorage) : [],
  roleTitle: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    loginSuccess: (state, action) => {
      state.loading = false;
      state.isAuthenticated = true;
      state.userId = action.payload.userId;
      state.token = action.payload.token;
      localStorage.setItem("token", action.payload.token);
      localStorage.setItem("userId", action.payload.userId);
      state.permission = action.payload.roles_permission;
      localStorage.setItem(
        "permission",
        JSON.stringify(action.payload.roles_permission),
      );
      state.roleTitle = action.payload.roleTitle;
      state.roleType = action.payload.roletype;
      console.log("userId", state.userId);
      console.log("STATE", state);
    },

    loginFailure: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.error = action.payload;
    },
    logout: (state) => {
      localStorage.removeItem("token");
      localStorage.removeItem("permission");
      return {
        ...initialState,
        token: null,
        isAuthenticated: false,
        userId: null,
      };
    },
  },
});

export const { loginStart, loginSuccess, loginFailure, logout } =
  authSlice.actions;

export default authSlice.reducer;
